import type { IconData } from '@stacksjs/iconify-core'

export const divisionCircle: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M45 24c0-11.598-9.402-21-21-21S3 12.402 3 24s9.402 21 21 21s21-9.402 21-21\"/><path d=\"M27 13a3 3 0 1 1-6 0a3 3 0 0 1 6 0m0 22a3 3 0 1 0-6 0a3 3 0 0 0 6 0m10.953-10.092c-.138 1.244-1.288 1.856-2.538 1.911C33.542 26.903 30.064 27 24 27s-9.542-.097-11.415-.18c-1.25-.056-2.4-.668-2.538-1.912A8 8 0 0 1 10 24q.002-.51.047-.908c.138-1.244 1.288-1.856 2.538-1.911C14.458 21.097 17.936 21 24 21s9.542.097 11.415.18c1.25.056 2.4.668 2.538 1.912q.046.398.047.908q-.002.51-.047.908\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default divisionCircle
